import React from 'react';
import {
  Box,
  Container,
  Typography,
  List,
  ListItem,
  ListItemText,
  Paper,
} from '@mui/material';

function PrivacyPolicy() {
  return (
    <Box sx={{ py: 8, bgcolor: 'background.default' }}>
      <Container maxWidth="lg">
        <Paper elevation={0} sx={{ p: { xs: 3, md: 6 }, bgcolor: 'background.paper', borderRadius: 2 }}>
          <Typography variant="h3" component="h1" gutterBottom sx={{ color: '#580100', fontWeight: 600, mb: 4 }}>
            Privacy Policy
          </Typography>

          <Typography paragraph sx={{ mb: 4 }}>
            At the Andheri Court's Bar Association, we are committed to protecting your privacy and ensuring that your personal information is handled responsibly and securely. This Privacy Policy outlines how we collect, use, and safeguard your information when you interact with our website, services, and communication platforms.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: '#580100', fontWeight: 600, mt: 4 }}>
            Information We Collect
          </Typography>
          <Typography paragraph>
            We collect personal data to provide better services and maintain effective communication. The types of information we collect include:
          </Typography>
          <List>
            <ListItem>
              <ListItemText 
                primary="Personal Information" 
                secondary="Name, contact number, email address, and postal address, primarily for membership registration and event communication."
                primaryTypographyProps={{ fontWeight: 600 }}
              />
            </ListItem>
            <ListItem>
              <ListItemText 
                primary="Usage Information" 
                secondary="IP address, browser type, and access times to understand how you interact with our website and improve user experience."
                primaryTypographyProps={{ fontWeight: 600 }}
              />
            </ListItem>
            <ListItem>
              <ListItemText 
                primary="Cookies" 
                secondary="Small files stored on your device to remember preferences and enhance browsing."
                primaryTypographyProps={{ fontWeight: 600 }}
              />
            </ListItem>
          </List>

          <Typography variant="h5" gutterBottom sx={{ color: '#580100', fontWeight: 600, mt: 4 }}>
            How We Use Your Information
          </Typography>
          <Typography paragraph>
            We use the information collected for purposes such as:
          </Typography>
          <List>
            <ListItem>
              <ListItemText 
                primary="Membership Management" 
                secondary="To process your membership application and renewal."
                primaryTypographyProps={{ fontWeight: 600 }}
              />
            </ListItem>
            <ListItem>
              <ListItemText 
                primary="Communication" 
                secondary="To send you updates on upcoming events, notifications, or legal resources."
                primaryTypographyProps={{ fontWeight: 600 }}
              />
            </ListItem>
            <ListItem>
              <ListItemText 
                primary="Analytics and Improvement" 
                secondary="To analyze website traffic and optimize your browsing experience."
                primaryTypographyProps={{ fontWeight: 600 }}
              />
            </ListItem>
            <ListItem>
              <ListItemText 
                primary="Compliance" 
                secondary="To adhere to legal obligations and maintain the integrity of our operations."
                primaryTypographyProps={{ fontWeight: 600 }}
              />
            </ListItem>
          </List>

          <Typography variant="h5" gutterBottom sx={{ color: '#580100', fontWeight: 600, mt: 4 }}>
            Data Sharing
          </Typography>
          <Typography paragraph>
            Your information will never be sold or shared with third parties for marketing purposes. We may share data:
          </Typography>
          <List>
            <ListItem>
              <ListItemText 
                primary="With trusted service providers for technical support or website maintenance."
              />
            </ListItem>
            <ListItem>
              <ListItemText 
                primary="When required by law or to comply with a legal obligation."
              />
            </ListItem>
          </List>

          <Typography variant="h5" gutterBottom sx={{ color: '#580100', fontWeight: 600, mt: 4 }}>
            Data Security
          </Typography>
          <Typography paragraph>
            We implement stringent security measures, such as encryption and secure servers, to protect your personal data from unauthorized access, alteration, or loss.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: '#580100', fontWeight: 600, mt: 4 }}>
            Your Rights
          </Typography>
          <Typography paragraph>
            You have the right to:
          </Typography>
          <List>
            <ListItem>
              <ListItemText primary="Access, update, or delete your personal information." />
            </ListItem>
            <ListItem>
              <ListItemText primary="Withdraw consent for data usage at any time." />
            </ListItem>
            <ListItem>
              <ListItemText primary="File a complaint if you believe your privacy rights have been violated." />
            </ListItem>
          </List>

          <Typography paragraph sx={{ mt: 4 }}>
            For any privacy concerns or to exercise your rights, email us at{' '}
            <Typography component="span" sx={{ color: '#580100' }}>
              andhericourtsba@gmail.com
            </Typography>
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}

export default PrivacyPolicy;
